import { usePayloadStore } from '@/stores/payload';
import AxiosClient from '../plugins/axios';
import jwtDecode from 'jwt-decode';
import momentTimezone from 'moment-timezone';

export const signUp = async (payload: any) => {
  const client = await AxiosClient();
  return (await client.post('accounts/register-user/', payload))?.data;
};

export const login = async (payload: any) => {
  const client = await AxiosClient();
  return (await client.post('accounts/login/', payload))?.data;
};

export const googleAuth = async (payload: any) => {
  const client = await AxiosClient();
  return (await client.post(`accounts/google-login/`, payload))?.data;
};

export const passwordReset = async (payload: any) => {
  const client = await AxiosClient();
  return (await client.post('accounts/password_reset/en/', payload))?.data;
};

export const resetPassword = async (payload: any) => {
  const client = await AxiosClient();
  return (await client.post(`accounts/password_reset/en/confirm/?token=${payload.token}`, payload))
    ?.data;
};

export const updatePassword = async (payload: any) => {
  const client = await AxiosClient();
  return (await client.put(`accounts/change_password/`, payload))
    ?.data;
};

export const logout = async () => {
  const client = await AxiosClient();
  return (await client.post('auth/logout/', {}))?.data;
};

const refreshToken = async (payload: any) => {
  const client = await AxiosClient();
  return (await client.post(`accounts/token/refresh/`, payload))?.data;
};

export const checkToken = async (unauthorized: boolean = false) => {
  const payloadStore = usePayloadStore();
  const decodedToken = jwtDecode(payloadStore?.payload.token);
  const exp = decodedToken.exp;
  const timezoneOffset = new Date().getTimezoneOffset();
  const currentTime = momentTimezone().utcOffset(timezoneOffset).unix();
  const expirationTime = momentTimezone.unix(exp).utcOffset(timezoneOffset);

  if (expirationTime.diff(momentTimezone(currentTime), 'seconds') < 300 || unauthorized) {
    refreshToken({ token: payloadStore?.payload.token, refresh: payloadStore?.payload.refresh })
      .then((res: any) => {
        payloadStore.change({ token: res.access, refresh: res.refresh });
        if (unauthorized) window.location.href = '/dashboard/documents';
      })
      .catch((err) => {
        payloadStore.clear();
        window.location.href = '/accounts/login/';
      });
  }
};

export const getProfile = async (id: string) => {
  const client = await AxiosClient();
  return (await client.get(`accounts/profile/${id}`))?.data;
};

export const updateProfile = async (id: string, payload: any) => {
  const client = await AxiosClient();
  return (await client.put(`accounts/profile/${id}`, payload))?.data;
};
